import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-studentstories-create",
  templateUrl: "./studentstories-create.component.html",
  styleUrls: ["./studentstories-create.component.scss"],
})
export class StudentstoriesCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private ActivatedRoute: ActivatedRoute,
    private router: Router,
    @Inject("API_ENDPOINT") private api_endpoint: string
  ) {}

  message = null;
  class = null;
  action = null;
  submitted = false;
  public studentstoriesForm: FormGroup;

  ngOnInit() {
    this.action = "Submit";
    this.ActivatedRoute.params.subscribe((params) => {
      let id = params["id"];

      // console.log(`${id}`);
      this.http
        .get<any>(this.api_endpoint + "/studentstoriesbyid/" + `${id}`)
        .subscribe(
          (data) => {
            // console.log(data.data);
            if (data.data != null) {
              this.action = "Update";
              this.studentstoriesForm.patchValue({
                _id: data.data._id,
                name: data.data.name,
                designation: data.data.designation,
                description: data.data.description,
                // priority: data.data.priority,
                image: data.data.image,
                imagealt: data.data.imagealt,
                meta_title: data.data.meta_title,
                meta_keyword: data.data.meta_keyword,
                meta_description: data.data.meta_description,
              });
            }
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    });

    this.studentstoriesForm = this.formBuilder.group({
      name: ["", Validators.required],
      designation: ["", Validators.required],
      description: ["", Validators.required],
      // priority: ['', Validators.required],
      image: ["", Validators.required],
      imagealt: ["", Validators.required],
      meta_title: [""],
      meta_keyword: [""],
      meta_description: [""],
      _id: [""],
    });
  }

  get f() {
    return this.studentstoriesForm.controls;
  }

  onFormSubmit() {
    this.submitted = true;

    if (this.studentstoriesForm.invalid) {
      return;
    }

    // console.log(this.coursename);
    if (this.action == "Submit") {
      var data = {
        name: this.studentstoriesForm.value.name,
        designation: this.studentstoriesForm.value.designation,
        description: this.studentstoriesForm.value.description,
        // "priority" : this.studentstoriesForm.value.priority,
        image: this.studentstoriesForm.value.image,
        imagealt: this.studentstoriesForm.value.imagealt,
        content_url: this.studentstoriesForm.value.name
          .toLowerCase()
          .replace(/ /g, "-"),
        admin: sessionStorage.getItem("adminName"),
        meta_title: this.studentstoriesForm.value.meta_title,
        meta_keyword: this.studentstoriesForm.value.meta_keyword,
        meta_description: this.studentstoriesForm.value.meta_description,
      };
      console.log(data);

      this.http
        .post<any>(this.api_endpoint + "/studentstories", data)
        .subscribe(
          (res) => {
            console.log(res);
            if (res.Error) {
              this.message = res.Error;
              this.class = "btn btn-primary";
              return;
            } else {
              this.message = "Successfully Added";
              this.class = "btn btn-success";
            }
            this.router.navigateByUrl("/adminhkbkcms/studentstories/list-page");
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured." + err);
            }
          }
        );
    } else {
      var data1 = {
        name: this.studentstoriesForm.value.name,
        designation: this.studentstoriesForm.value.designation,
        description: this.studentstoriesForm.value.description,
        // "priority" : this.studentstoriesForm.value.priority,
        image: this.studentstoriesForm.value.image,
        imagealt: this.studentstoriesForm.value.imagealt,
        content_url: this.studentstoriesForm.value.name
          .toLowerCase()
          .replace(/ /g, "-"),
        admin: sessionStorage.getItem("adminName"),
        _id: this.studentstoriesForm.value._id,
        meta_title: this.studentstoriesForm.value.meta_title,
        meta_keyword: this.studentstoriesForm.value.meta_keyword,
        meta_description: this.studentstoriesForm.value.meta_description,
      };
      // console.log(data1);
      this.http
        .put<any>(this.api_endpoint + "/studentstories/", data1)
        .subscribe(
          (res) => {
            console.log(res);
            if (res.Error) {
              this.message = res.Error;
              this.class = "btn btn-primary";
              return;
            } else {
              this.message = "Successfully Added";
              this.class = "btn btn-success";
            }
            this.router.navigateByUrl("/adminhkbkcms/studentstories/list-page");
          },
          (err: HttpErrorResponse) => {
            if (err.error instanceof Error) {
              console.log("Client-side error occured.");
            } else {
              console.log("Server-side error occured.");
            }
          }
        );
    }
  }
}
